import { origConsoleDebug, origConsoleError, origConsoleInfo, origConsoleLog, origConsoleWarn } from "../App";
import { LogLevel, LOG_LEVEL, SEQ_URL, SEQ_API_KEY } from "../Environment";
import { AccessInfoProps } from "../contexts/AccessTokenProvider";

// Signature of a logging function
export interface LogFn {
  (message?: any, ...optionalParams: any[]): void;
}

// Basic logger interface
export interface Logger {
  debug: LogFn;
  log: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
}

export class SeqLogger implements Logger {
  readonly _accessInfo: AccessInfoProps;

  constructor(accessInfo: AccessInfoProps) {
    this._accessInfo = accessInfo;
  }


  logErrorToSeq = (message?: any, ...optionalParams: any[]) => {
    this.logToSeq(LogLevel.error, message, ...optionalParams);
    origConsoleError.apply(message, optionalParams);
    return true;
  }

  logLogToSeq = (message?: any, ...optionalParams: any[]) => {
    this.logToSeq(LogLevel.info, message, ...optionalParams);
    origConsoleLog.apply(message, optionalParams);
    return true;
  }

  logWarnToSeq = (message?: any, ...optionalParams: any[]) => {
    this.logToSeq(LogLevel.warn, message, ...optionalParams);
    origConsoleWarn.apply(message, optionalParams);
    return true;
  }

  logInfoToSeq = (message?: any, ...optionalParams: any[]) => {
    this.logToSeq(LogLevel.info, message, ...optionalParams);
    origConsoleInfo.apply(message, optionalParams);
    return true;
  }

  logDebugToSeq = (message?: any, ...optionalParams: any[]) => {
    this.logToSeq(LogLevel.debug, message, ...optionalParams);
    origConsoleDebug.apply(message, optionalParams);
    return true;
  }

  logToSeq = (level: LogLevel, message?: any, ...optionalParams: any[]) => {

    const doNotLog = level < LOG_LEVEL;
    if (doNotLog)
      return false;

    // call seq to log
    let seq = require('seq-logging/browser');

    let logger = new seq.Logger({ serverUrl: SEQ_URL, apiKey: SEQ_API_KEY });

    if (typeof message === 'object'){
      return true; // this is a react component, don't log it
    }

    logger.emit({
      timestamp: new Date(),
      level: LogLevel[level],
      messageTemplate: message,
      properties: {
        UserName: this._accessInfo.email,
        Organization: this._accessInfo.selectedOrganizationName,
        OrganizationId: this._accessInfo.selectedOrganizationId,
        ComponentName: window.location.pathname,
      }
    });

    logger.close();

    return false;
  }

  debug = this.logDebugToSeq;
  log = this.logLogToSeq;
  info = this.logInfoToSeq;
  warn = this.logWarnToSeq;
  error = this.logErrorToSeq;
}

// const NO_OP: LogFn = (message?: any, ...optionalParams: any[]) => { };
